const general_event = require('../../config/general_event');
const { excute_linux_command, recursiveAsyncReadLine } = require('../../action/common');
const os = require("os");

const get_cpu_info = async () => {
  const cpu_info = os.cpus();
  return cpu_info;
}

let cpu_monitor_instance = null;

const cpu_monitor_start = (interval) => {
  if (check_cpu_monitor_status()) return;
  if (!interval) interval = 2500;
  const interval_callback = async () => {
    const cpu_info = await get_cpu_info();
    general_event.emit("cpu_monitor", cpu_info);
  }
  interval_callback();
  cpu_monitor_instance = setInterval(interval_callback, interval);
}

const cpu_monitor_stop = () => {
  clearInterval(cpu_monitor_instance);
  cpu_monitor_instance = null;
}

const check_cpu_monitor_status = () => {
  return cpu_monitor_instance !== null;
}

if (require.main === module) {
  const help_message = `
  1. get_cpu_info
  2. cpu_monitor_start
  3. cpu_monitor_stop
  4. check_cpu_monitor_status
  `
  console.log(help_message);

  const cpu_monitor_callback = (cpu_info) => {
    console.log(cpu_info);
  }
  recursiveAsyncReadLine(async (input) => {
    switch (input) {
      case "1":
        get_cpu_info().then((result) => {
          console.log(result);
        }).catch((error) => {
          console.error(error);
        });
        break;
      case "2":
        cpu_monitor_start();
        general_event.on("cpu_monitor", cpu_monitor_callback);
        break;
      case "3":
        general_event.off("cpu_monitor", cpu_monitor_callback);
        if (general_event.listenerCount("cpu_monitor") === 0) cpu_monitor_stop();
        break;
      case "4":
        console.log(check_cpu_monitor_status());
        break;
      default:
        console.log(help_message);
        break;
    }
  });
}

module.exports = {
  get_cpu_info,
  cpu_monitor_start,
  cpu_monitor_stop,
  check_cpu_monitor_status
}